import { useExchangeRate } from "hooks";

interface UseQuotePriceExchangeRatesResult {
  cadPerUsd: ExchangeRate | null;
  usdPerCad: ExchangeRate | null;
}

/**
 * The pair of rates a quote view needs, fetched once for the whole view.
 *
 * A list mixes CAD and USD bids and each price converts to its opposite, so a
 * view asks for both directions. That is two requests regardless of how many
 * quotes are on screen, and paging or filtering issues no more: the rate does
 * not depend on which quotes are rendered.
 */
export function useQuotePriceExchangeRates(): UseQuotePriceExchangeRatesResult {
  const { exchangeRate: cadPerUsd } = useExchangeRate({
    baseCurrencyCode: "USD",
    quoteCurrencyCode: "CAD",
  });
  const { exchangeRate: usdPerCad } = useExchangeRate({
    baseCurrencyCode: "CAD",
    quoteCurrencyCode: "USD",
  });

  return { cadPerUsd, usdPerCad };
}
